"use strict";

import { commonConstants, trafficFineConstants } from "../_constants";

const INITIAL_TRAFFIC_FINES_DATA_STATE = {
  restoreData: {},
  policeStationsList: [],
  payeeTypeId: null,
  payeeTypeName: null,
  finesList: [],
  payableAccounts: [],
  payableCards: [],
  validateAmountdata: {},
  payBilldata: {},
  selectedPoliceStation: {},
  confirmationData: {},
  customer: {},
  trafficFinePayeeServiceProviderLogo: null,
};

export function trafficFineReducer(
  state = INITIAL_TRAFFIC_FINES_DATA_STATE,
  action,
) {
  switch (action.type) {
    case trafficFineConstants.POLICE_STATION_LIST_REQUEST:
      return {
        ...state,
        policeStationsList: [],
        payBilldata: {},
      };

    case trafficFineConstants.POLICE_STATION_LIST_COMPLETE:
      return {
        ...state,
        policeStationsList: action.payload?.data?.policeStationDetails,
        payeeTypeId: action?.payload?.data?.trafficFinePayeeTypeId,
        payeeTypeName: action?.payload?.data?.trafficFinePayeeTypeName,
        customer: action?.payload?.data?.customer,
        trafficFinePayeeServiceProviderLogo:
          action?.payload?.data?.trafficFinePayeeServiceProviderLogo,
      };

    case trafficFineConstants.POLICE_STATION_LIST_ERROR:
      return {
        ...state,
        policeStationsList: [],
      };

    case trafficFineConstants.FINES_LIST_REQUEST:
      return {
        ...state,
        finesList: [],
      };

    case trafficFineConstants.FINES_LIST_COMPLETE:
      return {
        ...state,
        finesList: action.payload?.data?.fineTypeDetails,
      };

    case trafficFineConstants.FINES_LIST_ERROR:
      return {
        ...state,
        finesList: [],
      };

    case trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_COMPLETE:
      return {
        ...state,
        payableList: action.payload?.data?.accountList,
      };

    case trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_ERROR:
      return {
        ...state,
        payableList: [],
      };

    case trafficFineConstants.TRAFFIC_FINE_SET_PAYABLE_ACCOUNTS:
      return {
        ...state,
        payableAccounts: action?.payload,
      };
    case trafficFineConstants.TRAFFIC_FINE_SET_PAYABE_CARDS:
      return {
        ...state,
        payableCards: action?.payload,
      };

    case trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST:
      return {
        ...state,
        restoreData: action.payload?.restoreData,
      };

    case trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_COMPLETE:
      return {
        ...state,
        validateAmountdata: action.payload?.data,
        payBilldata: {},
      };
    case trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_ERROR:
      return {
        ...state,
        validateAmountdata: action.payload?.response?.errorResponse,
        payBilldata: {},
      };

    case trafficFineConstants.TRAFFIC_FINE_CLEAR_VALIDATION_AMOUNT_DATA:
      return {
        ...state,
        validateAmountdata: {},
      };

    case trafficFineConstants.TRAFFIC_FINE_CLEAR_FINE_FORM_DATA:
      return {
        ...state,
        restoreData: {},
        validateAmountdata: {},
        confirmationData: {},
      };

    case trafficFineConstants.TRAFFIC_FINE_PAYBILL_COMPLETE:
      return {
        ...state,
        payBilldata: action.payload?.data,
      };

    case trafficFineConstants.TRAFFIC_FINE_PAYBILL_COMPLETE:
      return {
        ...state,
        payBilldata: action.payload?.data,
      };

    case trafficFineConstants.TRAFFIC_FINE_PAYBILL_ERROR:
      return {
        ...state,
        payBilldata: {},
      };

    case trafficFineConstants.TRAFFIC_FINE_CLEAR_PAY_BILL_DATA:
      return {
        ...state,
        payBilldata: {},
      };

    case trafficFineConstants.TRAFFIC_FINE_SELECTED_POLICE_STATION:
      return {
        ...state,
        selectedPoliceStation: action.payload,
      };

    case trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_COMPLETE:
      return {
        ...state,

        confirmationData: action.payload?.data,
      };

    case trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_ERROR:
      return {
        ...state,
        confirmationData: action.payload?.response?.errorResponse,
      };
  }

  return state;
}
